import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { AlertEditDropDownIcon, DeleteIcon, DeleteIconAlert, EditIcon, PauseIcon, PlayIcon } from "../../Common/SvgIcon/CommonSvgIcons";
import { Edit, Pause } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { deleteAlertStatus, setEditData, updateAlertStatus } from "../../store/redux/slices/alertSlice";
import { convertToTimeZone } from "../../utils";
// import {
//   TableBody,
//   TableHeader,
// } from "@/components/ui/table";
// import { Badge } from "@/components/ui/badge";
const isAlertTopicUnavailable = (alert, allTopics = []) => {
  if (!allTopics?.length) return false;
  if (!alert?.job_details?.length) return false;
  return alert.job_details.every((job) => {
    const matched = allTopics.find((t) => String(t.job_id) === String(job.job_id));
    if (!matched) return true;
    const numericStatus = matched.is_active;
    if (numericStatus === 1 || numericStatus === 2) return true;
    const s = (matched.status || matched.job_status || '').toLowerCase();
    return s === 'deleted' || s === 'hibernate' || s === 'hibernated' || s === 'inactive';
  });
};



const Table = styled.table`
  border-collapse: collapse;
  text-align: center;
  margin-top:20px;
  margin-bottom:20px;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #ddd;
  height: auto;
  margin: 20px;
  background: ${({ isPaused }) => isPaused ? 'rgba(180, 180, 180, 0.2)' : 'transparent'};
  transition: background 0.2s ease-in-out;
  &:hover {
    background: ${({ isPaused }) => isPaused ? 'rgba(190, 190, 190, 0.45)' : 'rgba(154, 191, 194, 0.1)'};
  }
`;

const TableCell = styled.td`
  padding: 8px; /* Cell padding */
//   border-right: 1px solid #ddd;
  font-family: inherit;
  font-weight: 400;
  text-align: left;
  white-space: break-spaces;
`;
const TitleWithEditDropDownDiv = styled.div`
  display: grid;
  grid-template-columns: 92% 8%;
  gap:5px;
`;

const AlertDropDownDiv = styled.div`
    position: absolute;
    background: white;
    // box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 8px;
    box-shadow:rgb(0 0 0 / 29%) 1px 0px 15px;
    width: 100px;
    height: auto;
    padding: 4px 0px;
    top: 0px;
    right: -12px;
    border: 1px solid var(--Input-field-2, rgba(181, 181, 181, 1));
    border-radius: 4px;
    color: #000000;

    & > div {
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      padding-left: 14px;
      margin-bottom: 2px;
      cursor: pointer;
      color: #000000;

      &:hover {
        background: #8080804f;
      }
    }

`;

const TableHead = styled.th`
  height: 50px;
  padding: 10px;
  font-family: inherit;
  font-weight: 500;
  text-align: left;
`;

const ActiveStatus = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #5fe495;
  margin-right:6px;
`;

const InactiveStatus = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffd363;
  margin-right:6px;
`;

const UnavailableStatus = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #bdbdbd;
  margin-right: 6px;
`;
const AlertsTable = ({ data, setShowAddAlert = { setShowAddAlert }, allTopics = [] }) => {
  const dropdownRef = useRef(null);
  const closeTimeoutRef = useRef(null);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const dispatch = useDispatch()
  const handleDropdownToggle = (idx) => {
    setOpenDropdownIndex((prev) => (prev === idx ? null : idx));
  };
  const editFunc = (alert) => {
    setShowAddAlert(true)
    dispatch(setEditData(alert))
    setOpenDropdownIndex(-1)
  }

  const deleteFunc = (alert_id, status) => {

    let alert = alert_id?.id
    if (status == 'delete') {
      dispatch(deleteAlertStatus(
        {
          "alert_id": alert,
          "status": status
        }
      ))
    } else {
      dispatch(updateAlertStatus(
        {
          "alert_id": alert,
          "status": status
        }
      ))
    }

    handleDropdownToggle(null)

    setOpenDropdownIndex(-1)
  }
  const { personalDetailsData } =
    useSelector((state) => state.tenantSetting) || {};

  const convertTriggerType = (threshold, trigger_type, index) => {

    if ((!trigger_type || threshold === undefined || threshold === null) && threshold != 0) return ' ';


    const result = trigger_type.replace(/\s+/g, '');

    switch (result) {
      case 'Greaterthan(>)':
        return `Greater than ${threshold}`;
      case 'Lessthan(<)':
        return `Less than ${threshold}`;
      case 'Equalto(=)':
        return `Equal to ${threshold}`;
      case 'Increaseby(%)':
        return `Increase by ${threshold}%`;
      case 'DecreaseBy(%)':
      case 'Decrease By (% )': // handle typo variants
        return `Decrease by ${threshold}%`;
      case 'Spikesaboveaverage':
        return `Spikes above average ${threshold}`;
      case 'Dropbelowaverage':
        return `Drop below average ${threshold}`;
      default:
        return ' ';
    }
  };
  const formatDateTime = (value) => {
    if (!value) return "-- :--";

    const date = new Date(value);
    if (isNaN(date.getTime())) return "-- :--"; // invalid date

    // Format date as YYYY-MM-DD and time as HH:MM
    const formattedDate = date.toISOString().split('T')[0];
    const formattedTime = date.toTimeString().slice(0, 5); // HH:MM

    return `${formattedDate} ${formattedTime}`;
  }
  useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenDropdownIndex(null);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);
useEffect(() => {
  return () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
  };
}, []);
  return (
    <div>
      <Table>
        <thead>
          <TableRow style={{ background: ' linear-gradient(172.47deg, rgb(7, 51, 88) -63.2%, rgb(12, 63, 137) -17.55%, rgb(2, 102, 97) 54.92%, rgb(152, 229, 134) 105.06%, rgb(161, 216, 35) 116.76%)',color:'white' }}>
            <TableHead style={{ width: '10%' }}>Alert Name</TableHead>
            <TableHead style={{ width: '16%' }}>Alert Type</TableHead>
            <TableHead style={{ width: '17%' }}>Channel Source & Topic</TableHead>
            <TableHead style={{ width: '12%' }}>Threshold</TableHead>
            <TableHead style={{ width: '10%' }}>Trigger Frequency</TableHead>
            <TableHead style={{ width: '7%' }}>Notification Method(s)</TableHead>
            {/* <TableHead style={{ width: '15%' }}>Alert Users</TableHead> */}
            <TableHead style={{ width: '7%' }}>Status</TableHead>
            <TableHead style={{ width: '10%' }}>Created At</TableHead>

          </TableRow>
        </thead>
        <tbody>
          {data?.length > 0 && data?.map((alert, idx) => {
            let { formattedDate, formattedTime } = convertToTimeZone(
              alert?.creation_date,
              personalDetailsData?.app_preference?.time_zone,
              personalDetailsData?.app_preference?.time_format ===
                '12 Hour'
                ? true
                : false,
              personalDetailsData?.app_preference?.date_format
            );
            const isHibernated = isAlertTopicUnavailable(alert, allTopics);
            const isPaused = alert?.is_active === 1 || isHibernated;
            const grey = isPaused ? '#9e9e9e' : undefined;
            return (
              <TableRow key={idx} isPaused={isPaused}>
                <TableCell style={{ width: '10%', textTransform: 'capitalize', color: grey }}>
                  {alert?.alert_name}
                </TableCell>

                <TableCell className="font-medium" style={{ width: '16%', textTransform: 'capitalize', color: grey }}>
                  <TitleWithEditDropDownDiv ref={openDropdownIndex === idx ? dropdownRef : null} 
                    onMouseLeave={() => {
                        closeTimeoutRef.current = setTimeout(() => {
                          setOpenDropdownIndex(null);
                        }, 200);
                      }}
                      onMouseEnter={() => {
                        if (closeTimeoutRef.current) {
                          clearTimeout(closeTimeoutRef.current);
                        }
                      }}
                    >
                    <div>
                      {`${alert?.parameter} ${alert?.categories ? `- ${alert.categories}` : ''}`}
                    </div>
                    <div style={{ cursor: 'pointer' }} onClick={() => handleDropdownToggle(idx)}>
                      {AlertEditDropDownIcon}
                    </div>
                    {
                      openDropdownIndex == idx &&
                      <div style={{ position: 'relative' }}>
                        <AlertDropDownDiv>
                          { !isHibernated && (<div onClick={() => editFunc(alert)}>{EditIcon} Edit</div>)}
                          <div onClick={() => deleteFunc(alert, 'delete')}>{DeleteIconAlert} <span style={{ color: '#000000' }}>Delete</span></div>
                          {alert?.is_active === 0 ?
                            <div onClick={() => deleteFunc(alert, 'pause')}>{PauseIcon} <span style={{ color: '#000000' }}>Pause</span></div>
                            :
                            <div onClick={() => deleteFunc(alert, 'run')}>{PlayIcon} <span style={{ color: '#000000' }}>Play</span></div>
                          }
                        </AlertDropDownDiv>

                      </div>
                    }



                  </TitleWithEditDropDownDiv>
                </TableCell>
                <TableCell style={{ width: '17%', textTransform: 'capitalize', color: grey }}>
                  <div style={{
                    textTransform: 'capitalize',
                    maxHeight: '200px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 7, // number of lines depending on font-size/line-height
                    WebkitBoxOrient: 'vertical',
                    whiteSpace: 'normal',
                  }}>
                    {alert?.job_details?.map((job) => `${job?.title} - ${job?.channel}`).join(', ')}
                  </div></TableCell>
                <TableCell style={{ width: '12%', color: grey }}>{convertTriggerType(alert?.threshold, alert?.trigger_type, idx)}</TableCell>
                <TableCell style={{ width: '10%', textTransform: 'capitalize', color: grey }}>{alert?.scan_frequency}</TableCell>
                <TableCell style={{ width: '7%', textTransform: 'capitalize', color: grey }}>{alert?.notify_method?.map(i => i?.label).join(", ")}</TableCell>
                {/* <TableCell style={{ width: '15%', textTransform: 'capitalize' }}>{alert?.alert_user?.map(user => user.label).join(', ')}</TableCell> */}
                <TableCell style={{ width: '7%', color: grey }}>
                  {isHibernated ? (<><UnavailableStatus /><span style={{ color: '#9e9e9e' }}>Pause</span></>) : alert?.is_active === 0 ? (<>
                      <ActiveStatus />
                      Active
                    </>
                  ) : alert?.is_active === 1 ? (
                    <>
                      <InactiveStatus />
                      Pause
                    </>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell style={{ width: '10%', textTransform: 'capitalize', color: grey }}>
                  { formattedDate && formattedDate}{' '}
                  {formattedTime && formattedTime}</TableCell>

              </TableRow>
            )
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default AlertsTable;
